<mat-slide-toggle
    *ngIf="settings && settings.layout==='slide'"
    [(ngModel)]="checked"
    (change)="onChange($event)"
    [labelPosition]="(settings.label && settings.label.position) ? settings.label.position : null"
    [disabled]="disabled"
>
    {{computedLabel()}}
</mat-slide-toggle>
<mat-checkbox
    *ngIf="settings && (!settings.layout || settings.layout==='default')"
    [(ngModel)]="checked"
    (change)="onChange($event)"
    [disabled]="disabled"
    [labelPosition]="settings.label.position"
>
    {{computedLabel()}}
</mat-checkbox>
